import { L1_MENU_GROUPS } from '@atlassian/navigation-common';

import type { ItemDragAndDropGroup } from '../../types';

const l1ItemKey = Symbol('l1ItemKey');
const moreMenuKey = Symbol('moreMenuKey');

type TL1ItemData = {
	group: ItemDragAndDropGroup;
	isHidden: boolean;
	isHideable: boolean;
	isReorderable: boolean;
	[l1ItemKey]: true;
	label?: string;
	menuItemId: string;
};

export function getL1ItemData({
	menuItemId,
	label,
	isHidden,
	isHideable,
	isReorderable,
	group = L1_MENU_GROUPS.MENU,
}: {
	group: ItemDragAndDropGroup;
	isHidden: boolean;
	isHideable: boolean;
	isReorderable: boolean;
	label?: string;
	menuItemId: string;
}): TL1ItemData {
	return {
		menuItemId,
		label,
		isHidden,
		isHideable,
		isReorderable,
		[l1ItemKey]: true,
		group,
	};
}

export function isL1ItemData(data: Record<string | symbol, unknown>): data is TL1ItemData {
	return data[l1ItemKey] === true;
}

export function isL1ItemDataInGroup(
	data: TL1ItemData,
	groups: ItemDragAndDropGroup | ItemDragAndDropGroup[], // 'menu' | ['menu']
) {
	return Array.isArray(groups) ? groups.includes(data.group) : groups === data.group;
}

export const MORE_MENU_ITEM_ID = Symbol('moreMenuId');
export type MenuItemIdType = string | typeof MORE_MENU_ITEM_ID;

type TMoreMenuData = {
	menuItemId: typeof MORE_MENU_ITEM_ID;
	[moreMenuKey]: true;
};

export function getMoreMenuData(): TMoreMenuData {
	return {
		menuItemId: MORE_MENU_ITEM_ID,
		[moreMenuKey]: true,
	};
}

export function isMoreMenuData(data: Record<string | symbol, unknown>): data is TMoreMenuData {
	return data[moreMenuKey] === true;
}
